import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

type ApiFormCheckAccessControllInputputProps = { formId: number };
type ApiFormCheckAccessControllOutputProps = OutputBaseProps<{ allow: boolean }>;
export const apiFormCheckAccessControll = async (data: ApiFormCheckAccessControllInputputProps) => {
    const res = (await axios.get<ApiFormCheckAccessControllOutputProps>(`/api/form/check-access-controll/${data.formId}`)).data;
    return res;
};